import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

import Container from '../../../Core/Container';
import Points from '../../../../images/pts-icon.svg';
import WhitePlus from '../../../../images/white_plus.svg';

export const StyledContainer = styled(Container)`
  padding: 3rem 1.25rem 0;
  text-align: ${({ contentAlignment }) => contentAlignment || 'left'};
  background-color: ${({ backgroundColor }) =>
    backgroundColor
      ? themeGet(`colors.${backgroundColor}`)
      : themeGet('colors.white')};
`;

export const Heading = styled.h2`
  color: ${({ textColor }) =>
    textColor ? themeGet(`colors.${textColor}`) : themeGet('colors.main-text')};
  span {
    font-weight: inherit;
    font-size: inherit;
    color: inherit;
  }

  span.points {
    &:after {
      content: '';
      background-image: url(${Points});
      background-size: contain;
      background-position: center;
      background-repeat: no-repeat;
      position: relative;
      right: 0;
      bottom: 0.75rem;
      height: 1.8rem;
      width: 1.8rem;
      margin-left: 0.2rem;
      display: inline-block;

      @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
        width: 2rem;
        height: 2rem;
      }
    }
  }
`;

export const Subheading = styled.p`
  margin: 1.5rem auto;
  font-size: 1.25rem;
  line-height: 1.75rem;
  color: ${({ textColor }) =>
    textColor ? themeGet(`colors.${textColor}`) : themeGet('colors.main-text')};
`;

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  row-gap: 3.75rem;

  @media only screen and (min-width: ${({ theme }) => theme.breakpoints.md}) {
    flex-direction: row;
    column-gap: 3.75rem;
  }

  ${StyledContainer}.esso & {
    > div {
      position: relative;

      padding: 1.5rem;
      h3 {
        font-size: 1rem;
      }
      h3,
      p {
        width: 100%;
      }
      &:not(:last-child) {
        &:before {
          content: '';
          background-image: url(${WhitePlus});
          background-size: contain;
          background-position: center;
          background-repeat: no-repeat;
          position: absolute;
          height: 2.5rem;
          width: 2.5rem;
          // right side of flex box by half the size of the icon
          right: calc(50% - 1.25rem);
          // top side of flex box by half the row gap and half the size of the icon
          top: calc(100% + 1.875rem - 1.25rem);
          display: inline-block;

          @media only screen and (min-width: ${({ theme }) =>
              theme.breakpoints.md}) {
            // right side of the flex box by half the column gap and half the size of the icon
            right: calc(0% - 1.875rem - 1.25rem);
            // middle of the flex box by half the size of the icon
            top: calc(50% - 1.25rem);
          }
        }
      }

      @media only screen and (min-width: ${({ theme }) =>
          theme.breakpoints.md}) {
        width: calc((100% / ${({ columnCount }) => columnCount}));
        max-width: 408px;
      }
    }
  }
`;

export const Disclaimer = styled.p`
  color: ${({ textColor }) =>
    textColor ? themeGet(`colors.${textColor}`) : themeGet('colors.main-text')};
  font-size: 1.25rem;
  margin-top: 2rem;
  @media only screen and (min-width: ${({ theme }) => theme.breakpoints.md}) {
    margin-top: 1.25rem;
  }
`;
